const INITIAL_STATE = {
  situation: 'AVAILABLE',
  data: null,
  filterDate: {
    begin: '',
    end: ''
  },
};

export default function pointsReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case "SET_SITUATION_POINTS":
      return {
        ...state,
        situation: action.situation
      };
    case "SET_DATA_POINTS":
      return {
        ...state,
        data: action.data
      };
    case 'SET_DATE_POINTS': 
      return {
        ...state,
        filterDate: {
          begin: action.begin, 
          end: action.end
        }
      }
    default:
      return state;
  }
}
